import api from "@/lib/axios";

export enum MarketplaceProfileKeys {
  MY_PROFILE = "marketplace-profile-me",
  PROFILE_BY_ID = "marketplace-profile",
}

export enum AICategory {
  Automation = "automation",
  Agents = "ai-agents",
  Chatbots = "chatbots",
  ProductDevelopment = "product-development",
  DataAnalytics = "data-analytics",
  CreativeContent = "creative-content",
  TrainingWorkshops = "training-workshops",
  StrategyAdvisory = "strategy-advisory",
  Integrations = "integrations",
  ComplianceGovernance = "compliance-governance",
}

export const AI_CATEGORY_LABELS: Record<AICategory, string> = {
  [AICategory.Automation]: "Automation",
  [AICategory.Agents]: "Agents",
  [AICategory.Chatbots]: "Chatbots",
  [AICategory.ProductDevelopment]: "Product Development",
  [AICategory.DataAnalytics]: "Data & Analytics",
  [AICategory.CreativeContent]: "Creative & Content",
  [AICategory.TrainingWorkshops]: "Training & Workshops",
  [AICategory.StrategyAdvisory]: "Strategy & Advisory",
  [AICategory.Integrations]: "Integrations",
  [AICategory.ComplianceGovernance]: "Compliance & Governance",
};

export interface MarketplaceProfile {
  _id: string;
  profileImageUrl: string;
  title: string;
  location: string;
  oneLiner: string;
  background: string;
  skills: string[];
  aiCategory: AICategory[];
  licenseeId: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateMarketplaceProfilePayload {
  profilePhoto: string;
  title: string;
  location: string;
  oneLiner: string;
  background: string;
  skills: string[];
  aiCategory: AICategory[];
}

export const getMyMarketplaceProfile =
  async (): Promise<MarketplaceProfile | null> => {
    try {
      const response = await api.get("/marketplace-profiles/me");
      return response.data;
    } catch (error: any) {
      // Return null if profile doesn't exist yet
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  };

export const getMarketplaceProfileById = async (
  id: string,
): Promise<MarketplaceProfile> => {
  const response = await api.get(`/marketplace-profiles/${id}`);
  return response.data;
};

export const createOrUpdateMarketplaceProfile = async (
  payload: CreateMarketplaceProfilePayload,
): Promise<MarketplaceProfile> => {
  const response = await api.post("/marketplace-profiles", payload);
  return response.data;
};
